import { RouteParam } from ".";
import ComplaintInsights from "../ui/pages/complaint/complaint_insights";
import CreateComplaintPage from "../ui/pages/complaint/create";
import ComplainantDetailPage from "../ui/pages/complaint/detail";
import IncidentTrackerPage from "../ui/pages/complaint/incident_tracker/incident_tracker";
import ComplaintListingPage from "../ui/pages/complaint/listing";
import WordCloudPage from "../ui/pages/complaint/word_cloud";
import { ACTION, MODULE } from "../utils/enums";
import { urls } from "../utils/urls";

const complaint_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.create_complaint,
    component: CreateComplaintPage,
    main_module: MODULE.complaint_panel,
    module: MODULE.complaint,
    action: [ACTION.CREATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.complaints,
    component: ComplaintListingPage,
    main_module: MODULE.complaint_panel,
    module: MODULE.complaint,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.complaint_detail,
    component: ComplainantDetailPage,
    main_module: MODULE.complaint_panel,
    module: MODULE.complaint,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.service_desk_tracker,
    component: IncidentTrackerPage,
    main_module: MODULE.complaint_panel,
    module: MODULE.complaint,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.complaint_word_cloud,
    component: WordCloudPage,
    main_module: MODULE.complaint_panel,
    module: MODULE.complaint,
    action: [ACTION.CREATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.compliant_insights,
    component: ComplaintInsights,
    main_module: MODULE.complaint_panel,
    module: MODULE.complaint,
    action: [ACTION.READ],
    operator: "or",
  },
];

export default complaint_routes;
